<template>
  <div>
    <v-row>
      <v-col>
        <naj-data-table
          no-header
          :headers="headers"
          :loading="loading"
          :items="branch.list"
          pagination
          :items-per-page="pagination.pageSize"
          :page-index="pagination.pageIndex"
          :server-items-length="pagination.totalCount"
          @update:pageIndex="onPageChange"
        >
          <template slot-scope="{item}">
            <v-icon
              color="primary"
              @click="showModal(item)"
            >
              mdi-eye
            </v-icon>
          </template>
        </naj-data-table>
      </v-col>
    </v-row>
    <naj-modal
      ref="branchModal"
      :title="`${locale.branches.branch}`"
      :width="1200"
      show-footer-close-button
      @onClose="onCloseModal"
    >
      <branch
        :form-model="formModel"
        :loading="loading"
      ></branch>
    </naj-modal>
  </div>
</template>

<script>
import Branch from './branch.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');

export default {
  components: { Branch },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      locale: this.local.bankruptcy.requestDetails,
      branch: { list: [] },
      headers: [
        {
          value: 'index',
          text: this.local.bankruptcy.requestDetails.sequence,
        },
        {
          value: 'name',
          text: this.local.bankruptcy.requestDetails.branches.theBranch,
        },
        {
          value: 'commercialRegistrationNumber',
          text: this.local.bankruptcy.requestDetails.branches.commercialRegisterNo,
        },
        {
          value: 'unifiedNumber',
          text: this.local.bankruptcy.requestDetails.branches.unifiedNumber,
        },

      ],
      pagination: {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      formModel: {},
      loading: false,
    };
  },
  computed: {},
  mounted() {
    this.pagination.pageIndex = 0;
    this.loadData();
  },
  methods: {
    ...mapActions(['getBranchesByRequestObjectKey', 'getBranch']),
    loadData() {
      this.loading = true;
      this.getBranchesByRequestObjectKey({
        requestObjectKey: this.requestObjectKey,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.branch = { ...data };
          this.branch.list.forEach((element, index) => {
            element.index = index + 1 + (this.pagination.pageSize * this.pagination.pageIndex);
          });
          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
        });

    },
    onPageChange(pageIndex) {
      this.pagination = {
        ...this.pagination,
        pageIndex,
      };
      this.loadData();
    },
    showModal(model) {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: model.objectKey,
      };
      this.loading = true;
      this.getBranch(params)
        .then((res) => {
          this.formModel = res.data;
          this.isEditMode = true;
          this.$refs.branchModal.show();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCloseModal() {
      for (const key in this.formModel)
        if (Object.hasOwnProperty.call(this.formModel, key))
          this.$set(this.formModel, key, undefined);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: #faf9f4 0% 0% no-repeat padding-box;
}
</style>